import { IButtonStyles, IStackStyles, ITheme } from '@fluentui/react';

export const backButtonStyles = (isGetHelp: boolean, color: string): IButtonStyles => ({
  root: {
    width: 'fit-content',
    padding: '0px 16px',
    color: color,
    fontSize: '14px',
    fontWeight: 'normal',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    margin: isGetHelp ? '0 !important' : null,
    marginTop: isGetHelp ? null : '30px',
  },
  
  rootHovered: {
    color: color,
  },

  iconHovered: {
    color: color,
  },

  rootPressed: {
    color: color,
  },

  rootExpanded: {
    color: color,
  },

  iconPressed: {
    color: color,
  },

  rootDisabled: {
    color: color,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
  },

  rootChecked: {
    color: color,
  },

  iconChecked: {
    color: color,
  },

  icon: {
    color: color,
  }
});

export const backBtnLabelStyles: IStackStyles = {
  root: {
    margin: '0px 0px 3px 0px',
    lineHeight: '2',
    paddingLeft: '15px',
  },
};

export const getBackBtnIconStyles = (props: { theme?: ITheme }) => {
  const { theme } = props;
  return {
    root: {
      margin: '0px 6px 0px 0px',
      verticalAlign: 'middle',
      color: theme ? theme.palette.black : '#333'
    },
  }
};